import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmModal } from '@app/shared/modals';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { WorkFlowService } from '../../../services';

@Component({
  selector: 'app-workflow-row',
  templateUrl: './workflow-row.component.html',
  styleUrls: ['./workflow-row.component.scss'],
})
export class WorkflowRowComponent implements OnInit {
  @Input('workflow') workflow: any;
  @Input('activate') activate: boolean;
  @Output() activateWorkflow: any = new EventEmitter();
  @Output() deActivateWorkflow: any = new EventEmitter();
  @Output() updateWorkflow: any = new EventEmitter();
  permissions: Array<any> = [];

  name;

  constructor(
    private workflowService: WorkFlowService,
    public modalService: SuiModalService,
    private router: Router
  ) {
    if (window.localStorage.getItem('permission')) {
      this.permissions = JSON.parse(window.localStorage.getItem('permission'));
    }
  }

  ngOnInit(): void {
    this.name = JSON.parse(this.workflow.createdBy).name;
  }

  removeUnderScore(e) {
    if (e != null) {
      return e.replaceAll('_', ' ');
    }
    return '-';
  }
  checkPermission(id: string, action: string): boolean {
    if (
      this.permissions.filter((res) => res.permissionId === id)[0] &&
      this.permissions.filter((res) => res.permissionId === id)[0][action] ===
        'true'
    ) {
      return true;
    } else {
      return false;
    }
  }

  viewWorkflow(workflow) {
    window.localStorage.setItem('workflow', JSON.stringify(workflow));
    this.router.navigate([
      `/admin/setting/workflow/${workflow['jpaWorkflowGroupViewPK']['workflowGroupId']}/detail`,
    ]);
  }
}
